module.exports = __webpack_public_path__ + "res/ic_menu_game.6ebcaec5f0f868764e2308e5a3629ac2.png";